import styled, { css } from 'styled-components';
import { Typography } from '../../../../global/theme';
import { mobile_xl } from '../../../../global/mediaQueryMixin';

interface Props {
  isMilestoneBox?: boolean;
  status?: number;
  ProgressPercentage?: number;
  isBorderColor?: string;
}

const Group = styled.div<Props>`
  display: flex;
  max-width: 700px;
  width: 100%;
  margin: 0 auto;
  flex-direction: column;
  gap: 20px;
  padding-block: 20px 24px;
  scrollbar-width: none;
  /* overflow: auto; */
  ::-webkit-scrollbar {
    display: none;
  }
  ${mobile_xl(css`
    padding-block: 8px 80px;
    gap: 16px;
  `)}
`;
const PodcastDiv = styled.div`
  max-width: 700px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
const Top = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  ${mobile_xl(css`
    display: none;
  `)}
`;

const Heading = styled.h1`
  ${Typography.heading_md}
  margin: 0;
  color: var(--text-primary);
  ${mobile_xl(css`
    display: none;
  `)}
`;

const Profiles = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
  align-items: center;
  .hide-button {
    display: none;
  }
  :hover {
    cursor: pointer;
    .hide-button {
      display: block;
    }
  }

  ${mobile_xl(css`
    gap: 4px 8px;
    .hide-button {
      display: block;
    }
  `)}
`;
const ProfileBorder = styled.div`
  width: 34px;
  height: 34px;
  border: 0.5px solid var(--border-primary);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const ProfileGroup = styled.div`
  display: flex;
  gap: 2px;
  height: 34px;
  border: 0.5px solid var(--border-primary);
  border-radius: 30px;
  align-items: center;
  justify-content: center;
  padding: 0 2px;
`;
const TaskDiv = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: 12px;
  box-shadow: var(--shadow-card);
  background-color: var(--background-primary);
  padding: 15px 16px;
  display: flex;
  gap: 20px;
  ${mobile_xl(css`
    flex-direction: column;
    padding: 16px;
  `)}
`;
const Task = styled.div`
  display: flex;
  gap: 16px;
  max-width: 209px;
  width: 100%;
  border-right: 0.5px solid var(--border-primary);
  :last-child {
    border-right: none;
  }
  ${mobile_xl(css`
    border: none;
    align-items: center;
  `)}
`;
const Icon = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  background-color: var(--background-tertiary);
  width: 46px;
  height: 46px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  p {
    ${Typography.body_md_medium}
    margin: 0;
    color: var(--text-secondary);
  }
  h2 {
    ${Typography.heading_lg}
    margin: 0;
    color: var(--text-primary);
  }
  /* override font size in h2  */
  ${mobile_xl(css`
    h2 {
      font-size: 20px;
      line-height: 24px;
    }
  `)}
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  p {
    ${Typography.heading_sm}
    margin: 0;
    color: var(--text-primary);
  }
`;

const MilestoneBox = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: 12px;
  box-shadow: var(--shadow-card);
  background-color: var(--background-primary);
  padding: 15px 16px 5px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  p {
    ${Typography.heading_sm}
    margin: 0;
    color: var(--text-primary);
  }
  ${mobile_xl(css`
    padding: 16px 16px 6px;
  `)}
`;
const Milestone = styled.div``;
const Div = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0 9px;
  border-bottom: 0.5px solid var(--border-primary);
  :last-child {
    border-bottom: none;
    padding: 10px 0;
  }
  ${mobile_xl(css`
    gap: 16px;
  `)}
`;
const LeftDiv = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  .header-icon {
    fill: var(--background-primary);
    stroke: var(--text-secondary);
    path {
      stroke: none;
    }
  }
  .milestone-icon {
    fill: var(--background-primary);
    path.border {
      stroke: var(--text-secondary);
    }
  }
  p {
    ${Typography.body_md_medium}
    margin: 0;
    color: var(--text-primary);
    span {
      padding-left: 6px;
    }
  }
  ${mobile_xl(css`
    align-items: flex-start;
  `)}
`;
const SubDiv = styled.div`
  display: flex;
  gap: 6px;
  ${mobile_xl(css`
    flex-wrap: wrap;
    max-width: 231px;
    width: 100%;
  `)}
`;
const RightDiv = styled.div`
  ul {
    display: flex;
    flex-wrap: nowrap;
    list-style-type: none;
    padding: 0;
    margin: 0;
    justify-content: flex-end;
    height: 24px;
  }
  li {
    margin-left: -9px;
    width: 24px;
  }
`;
const AvatarImage = styled.div`
  display: flex;
  align-items: center;
  border-radius: 50%;

  > div > img {
    max-width: 100%;
  }
`;

const GraphBox = styled.div`
  border: 0.5px solid var(--border-primary);
  border-radius: 12px;
  box-shadow: var(--shadow-card);
  background-color: var(--background-primary);
  padding: 15px 16px;
  display: flex;
  gap: 12px;
  flex-direction: column;
`;
const ViewDropdown = styled.div`
  .menuStyle {
    display: flex;
    flex-direction: column;
    background: var(--background-primary);
    border: 0.5px solid var(--border-primary);
    border-radius: 8px;
    margin: 0px;
    padding: 6px 0;
    height: 100%;
    max-height: 205px;
    overflow: auto;
    ::-webkit-scrollbar {
      display: none;
    }
    .menuitem {
      color: var(--text-primary);
      ${Typography.body_md}
      margin: 0;
      padding: 6px 12px;
      :hover {
        background: var(--neutral-secondary);
        border-radius: 0;
      }
    }
  }
`;
const Status = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 4px 6px 4px 12px;
  gap: 10px;
  background: var(--background-primary);
  border-radius: 8px;
  border: 0.5px solid var(--border-primary);
  width: 134px;
  cursor: pointer;
  p {
    ${Typography.body_md}
    margin: 0;
    color: var(--text-primary);
  }
  .fill-color {
    stroke: var(--text-primary);
  }
  .dropdown-icon {
    transform: rotate(180deg);
  }
`;
const Dropdowns = styled.div`
  position: relative;
`;
const FileEmptyState = styled.div<Props>`
  padding-bottom: 15px;
  ${(props) =>
    props.isMilestoneBox &&
    css`
      padding-bottom: 25px;
    `}
`;

const LoadingImage = styled.div`
  position: relative;
  left: 50%;
  width: max-content;
  margin: 187px 0;
`;
const ResourcesSection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  ${mobile_xl(css`
    flex-direction: column;
  `)}
`;
const ResourceTitle = styled.div`
  ${Typography.body_md_medium};
  color: var(--text-primary);
  padding: 3px 0;
`;
const ResourcesDropdownHeading = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px;
  border-radius: 6px;
  p {
    margin: 0;
    ${Typography.body_md_medium};
    color: var(--text-secondary);
  }
  :hover {
    background-color: var(--neutral-secondary);
    p {
      color: var(--text-primary);
    }
    svg {
      path {
        fill: var(--text-primary);
      }
    }
  }
  &.hide-text {
    padding: 5px;
    p {
      display: none;
    }
  }
`;

const AddedLinkBox = styled.div`
  background-color: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: 6px;
  padding: 2px 4px 2px 8px;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  &:hover {
    background-color: var(--neutral-secondary);
  }
`;

const LinkIcon = styled.div`
  display: flex;
`;

const Text = styled.p`
  margin: 0;
  ${Typography.body_md_medium};
  color: var(--text-primary);
`;
const MoreIcon = styled.div`
  width: 18px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  cursor: pointer;
  .fill-color {
    fill: var(--text-secondary);
    stroke: var(--text-secondary);
  }
  &:hover {
    background-color: var(--background-muted);
    .fill-color {
      fill: var(--text-primary);
      stroke: var(--text-primary);
    }
  }
`;

const ResourcesFileSection = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

const WrapperDiv = styled.div`
  display: flex;
  /* height: calc(100dvh - 51px); */
  ${mobile_xl(css`
    /* height: calc(100vh - 177px); */
    height: unset;
  `)}
`;

const CardMainDiv = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px;
  border: 0.5px solid var(--border-primary);
  background: var(--background-primary);
  box-shadow: var(--shadow-card);
`;

const Title = styled.div`
  ${Typography.heading_sm};
  color: var(--text-primary);
`;

const ContentDiv = styled.div`
  ${Typography.body_md_medium};
  color: var(--text-primary);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;

const TopSection = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const BottomSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  width: 100%;
`;

const TextDiv = styled.p`
  ${Typography.body_sm_medium};
  color: var(--text-secondary);
`;

const RowDiv = styled.div`
  display: grid;
  grid-template-columns: 140px 1fr;
  align-items: center;
  gap: 16px;
  width: 100%;
`;

const ChatContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const ProgressSection = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
`;

const StatusText = styled.p`
  ${Typography.body_md};
  color: var(--text-primary);
  margin: 0;
`;

const UserName = styled.p`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  margin: 0;
  ${Typography.body_md};
  color: var(--text-primary);
  overflow: hidden;
`;

const EmptyContent = styled.div`
  ${Typography.body_sm_medium};
  color: var(--text-secondary);
  display: flex;
  align-items: center;
`;

export {
  Group,
  PodcastDiv,
  Top,
  Heading,
  Profiles,
  ProfileBorder,
  ProfileGroup,
  TaskDiv,
  Task,
  Icon,
  Content,
  Header,
  MilestoneBox,
  Milestone,
  Div,
  LeftDiv,
  RightDiv,
  SubDiv,
  AvatarImage,
  GraphBox,
  ViewDropdown,
  Status,
  Dropdowns,
  FileEmptyState,
  LoadingImage,
  ResourcesSection,
  ResourceTitle,
  ResourcesDropdownHeading,
  AddedLinkBox,
  LinkIcon,
  Text,
  MoreIcon,
  ResourcesFileSection,
  WrapperDiv,
  CardMainDiv,
  Title,
  ContentDiv,
  TopSection,
  BottomSection,
  TextDiv,
  RowDiv,
  ChatContent,
  ProgressSection,
  StatusText,
  UserName,
  EmptyContent
};
